import { BrandMediaKit, Button, defaultUser, Media, MediaKit } from '@hub/shared'
import React from 'react'
import { useTranslation } from 'react-i18next'
import PhotoGrid from '../photo-grid/photo-grid.component'
import './card-brand.component.scoped.scss'
import './card-brand.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  brand?: BrandMediaKit
  mediakit?: MediaKit
  onChangeMediaKit?: (mediakit: MediaKit) => void
  idProfile?: number | string
  onOpenModalLinkBrand?: (openModalLinkBrand: boolean) => void
  onProfileIndexSelected?: (profileIndex?: string) => void
}

export default ({ className = '', brand, onChangeMediaKit, mediakit, idProfile, onOpenModalLinkBrand, onProfileIndexSelected }: Props) => {
  const [t] = useTranslation('cardBrand')

  const handleChangeMediaKit = () => {
    if (onChangeMediaKit && typeof onChangeMediaKit === 'function') {
      onChangeMediaKit({ ...mediakit })
    }
  }

  const handleClickRemoveBrand = () => {
    const index = mediakit?.whoAnnounced?.brands?.findIndex((b) => {
      return b?.profile?.id === brand?.profile?.id
    })
    if (index != undefined && index >= 0) {
      mediakit?.whoAnnounced?.brands?.splice(index, 1)
    }
    handleChangeMediaKit()
  }

  const handleOpenModalLinkBrand = () => {
    if (onOpenModalLinkBrand && typeof onOpenModalLinkBrand === 'function') {
      onOpenModalLinkBrand(true)
    }
  }

  const handleChangeBrand = () => {
    if (onProfileIndexSelected && typeof onProfileIndexSelected === 'function') {
      onProfileIndexSelected(brand?.profile?.id)
    }
    handleOpenModalLinkBrand()
  }

  const handleChangeImage = (newImage: Media) => {
    const brandUpdated: BrandMediaKit = { ...brand!, image: newImage }
    const index = mediakit?.whoAnnounced?.brands?.findIndex((b) => b?.profile?.id === brand?.profile?.id)
    if (mediakit?.whoAnnounced?.brands?.length && index != undefined && index >= 0) {
      mediakit?.whoAnnounced?.brands?.splice(index, 1, brandUpdated)
    }
    handleChangeMediaKit()
  }

  return (
    <div
      className={`card-brand ${className} ${brand ? '' : 'empty'}`}
      role="button"
      tabIndex={0}
      onClick={() => !brand && handleOpenModalLinkBrand()}
      style={{ cursor: brand ? 'auto' : 'pointer' }}
    >
      {brand && (
        <div className="trash-action" role="button" tabIndex={0} onClick={() => handleClickRemoveBrand()}>
          <i className="fa-regular fa-trash" style={{ color: 'var(--white-html)' }}></i>
        </div>
      )}
      <main className="card-brand-main">
        <div className="background-image-brand">
          {brand && (
            <PhotoGrid
              size={1}
              requiredSize={1}
              featuredPhoto={1}
              photos={mediakit?.whoAnnounced?.brands?.filter((b) => b?.profile?.id === brand?.profile?.id).map((brand) => brand?.image)}
              idProfile={idProfile!}
              onChange={([newImage]) => handleChangeImage(newImage)}
              smallCardSize="100%"
              hiddenNumberPhotos
            />
          )}
        </div>
        <div className="main-image-brand" onClick={() => handleChangeBrand()} role="button" tabIndex={0} style={{ cursor: 'pointer' }}>
          {brand?.image && (
            <figure>
              <img
                src={brand?.profile?.picture}
                alt={brand?.image?.usuario?.nome}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null
                  currentTarget.src = defaultUser
                }}
              />
            </figure>
          )}
        </div>
      </main>
      <section className="card-brand-body">
        {!brand ? (
          <Button
            width="inherit"
            size="sm"
            inverted
            color="transparent"
            borderColor="var(--primary_color)"
            textColor="var(--primary_color)"
            style={{ padding: '0.25rem 1rem' }}
            onClick={() => handleOpenModalLinkBrand()}
          >
            <span style={{ whiteSpace: 'nowrap' }}>{t('addPublication')}</span>
          </Button>
        ) : (
          <span title={`@${brand?.profile?.username}`} className="brand-username">{`@${brand?.profile?.username}`}</span>
        )}
      </section>
    </div>
  )
}
